import { Injectable } from '@angular/core'
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
  Resolve,
} from '@angular/router'
import { Observable } from 'rxjs'
import { Logger } from '../../logger.service'
import { map, catchError } from 'rxjs/operators'
import { Promotions } from '../../models'
import { PrinterSettingsService } from '@hmp/services/hmp/printer-settings/printer-settings.service'

const log = new Logger('PrinterSettingsDetailResolver')
@Injectable({ providedIn: 'root' })
export class PrinterSettingsDetailResolver
  implements Resolve<Observable<Promotions>> {
  constructor(
    private printerSettingsService: PrinterSettingsService,
    private router: Router
  ) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<any> {
    let mode = route.params['mode']
    let _id = route.params['id']
    
    return this.printerSettingsService.getDetail(_id).pipe(
      map(data => {
        log.debug('Data: ', data)
        return data
      }),
      catchError(err => this.router.navigate(['/printer-settings']))
    )
  }
}
